/* eslint-disable linebreak-style */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  transform(phNumber: string) {
    const areaCodeStr = phNumber.slice(0, 3);
    const midSectionStr = phNumber.slice(3, 6);
    const lastSectionStr = phNumber.slice(6);

    return `(${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }
}
